export default "__VITE_ASSET__Ck4CSw_F__"